import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageTextField, EditPageSelect, EditPageCheckbox } from './../../../../common/EditPage';
import { useParams, useNavigate } from 'react-router-dom';
import { getOne, create } from './../../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';

const ClientAccountSmppAccountsCreate = () => {
    const [metadata, setMetadata] = useState({});
    const [data, setData] = useState({
        ATRUSERNAME: '',
        ATRPASSWORD: '',
        ATRBIND: 'transceiver',
        ATRCODING: '0',
        ATRSTATUS: true
    });
    const { account_id } = useParams();
    const navigate = useNavigate();
    
    useEffect(() => {
        getOne(`/admin/clients/clients/${account_id}/smppaccounts/`, 'new').then(response => {
            setMetadata(response.data.metadata);
        }).catch(error => {
            toast.error("Error fetching SMPP accounts metadata: " + error.message, {});
        });
    }, [account_id]);

    const handleSave = () => {
        create(`/admin/clients/clients/${account_id}/smppaccounts/`, {data: data}).then(() => {
            navigate(`/clients/clients/${account_id}/smppaccounts`);
        }).catch(error => {
            toast.error("Error creating SMPP account: " + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate(`/clients/clients/${account_id}/smppaccounts`);
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={handleSave} handleCancel={handleCancel}>
                <EditPagePanel>
                    <EditPageTextField 
                        label="SMPP Username" 
                        id="ATRUSERNAME" 
                        onChange={onChange} 
                        value={data.ATRUSERNAME}
                        placeholder="smppusername"
                    />
                    <EditPageTextField 
                        label="Password" 
                        id="ATRPASSWORD" 
                        onChange={onChange} 
                        value={data.ATRPASSWORD}
                        type="password"
                        placeholder="Enter password"
                    />
                    <EditPageSelect 
                        label="Rate Profile" 
                        id="ATRPRODUCTID" 
                        onChange={onChange} 
                        value={data.ATRPRODUCTID}
                        options={metadata?.products?.values || {}}
                        placeholder="Select product"
                        nullable
                    />
                    <EditPageSelect 
                        label="Bind" 
                        id="ATRBIND" 
                        onChange={onChange} 
                        value={data.ATRBIND}
                        options={{
                            'transceiver': 'Transceiver',
                            'transmitter': 'Transmitter',
                            'receiver': 'Receiver'
                        }}
                        placeholder="Select bind type"
                    />
                    <EditPageSelect 
                        label="Coding" 
                        id="ATRCODING" 
                        onChange={onChange} 
                        value={data.ATRCODING}
                        options={{
                            '0': 'Default',
                            '1': 'IA5 (ASCII)',
                            '3': 'Latin 1',
                            '8': 'UCS2'
                        }}
                        placeholder="Select coding"
                    />
                    <EditPageCheckbox 
                        label="Enabled" 
                        id="ATRSTATUS" 
                        onChange={onChange} 
                        value={data.ATRSTATUS}
                    />
                </EditPagePanel>
            </EditPage>
        </>
    )
}   

export default ClientAccountSmppAccountsCreate;